import api from 'api'
import { queryParamSerializer } from 'lib/api/queryParamSerializer'
import { WorkerClassification } from 'constants/workerClassification'

export type GetUnpaidShiftsOptions = {
  userId?: number
  shiftId?: number
  companyId?: number
  status?: string[]
  type?: WorkerClassification[]
  endDate?: string // ISO date string (YYYY-MM-DD)
  page?: number
  pageSize?: number
}

export type UnpaidShift = {
  workId: number
  userId: number
  userName: string | null
  amount: number
  shiftId: number
  shiftCompletedAt: string | null
  shiftCurrentStatus: string
  companyId: number | null
  companyName: string | null
  positionId: number | null
  positionName: string | null
  statusTransitions: Record<string, string>
  w2: boolean
}

export type GetUnpaidShiftsResponse = {
  items: UnpaidShift[]
  totalRows: number
  totalPages: number
  currentPage: number
  pageSize: number
}

export const getUnpaidShifts = async ({
  userId,
  shiftId,
  companyId,
  status,
  type,
  endDate,
  page = 0,
  pageSize = 50,
}: GetUnpaidShiftsOptions): Promise<GetUnpaidShiftsResponse> => {
  const response = await api.get('/admin/unpaid_shifts', {
    params: {
      user_id: userId,
      shift_id: shiftId,
      company_id: companyId,
      end_date: endDate,
      status,
      type,
      page,
      page_size: pageSize,
    },
    paramsSerializer: queryParamSerializer,
  })
  return response.data
}
